export default {
    MONTHS: [
        { name: "January", abbreviation: "Jan" },
        { name: "February", abbreviation: "Feb" },
        { name: "March", abbreviation: "Mar" },
        { name: "April", abbreviation: "Apr" },
        { name: "May", abbreviation: "May" },
        { name: "June", abbreviation: "Jun" },
        { name: "July", abbreviation: "Jul" },
        { name: "August", abbreviation: "Aug" },
        { name: "September", abbreviation: "Sep" },
        { name: "October", abbreviation: "Oct" },
        { name: "November", abbreviation: "Nov" },
        { name: "December", abbreviation: "Dec" }
    ],
    STATES: [
        { name: "Alabama", abbreviation: "AL" },
        { name: "Alaska", abbreviation: "AK" },
        { name: "American Samoa", abbreviation: "AS" },
        { name: "Arizona", abbreviation: "AZ" },
        { name: "Arkansas", abbreviation: "AR" },
        { name: "California", abbreviation: "CA" },
        { name: "Colorado", abbreviation: "CO" },
        { name: "Connecticut", abbreviation: "CT" },
        { name: "Delaware", abbreviation: "DE" },
        { name: "District of Columbia", abbreviation: "DC" },
        { name: "Federated States of Micronesia", abbreviation: "FM" },
        { name: "Florida", abbreviation: "FL" },
        { name: "Georgia", abbreviation: "GA" },
        { name: "Guam", abbreviation: "GU" },
        { name: "Hawaii", abbreviation: "HI" },
        { name: "Idaho", abbreviation: "ID" },
        { name: "Illinois", abbreviation: "IL" },
        { name: "Indiana", abbreviation: "IN" },
        { name: "Iowa", abbreviation: "IA" },
        { name: "Kansas", abbreviation: "KS" },
        { name: "Kentucky", abbreviation: "KY" },
        { name: "Louisiana", abbreviation: "LA" },
        { name: "Maine", abbreviation: "ME" },
        { name: "Marshall Islands", abbreviation: "MH" },
        { name: "Maryland", abbreviation: "MD" },
        { name: "Massachusetts", abbreviation: "MA" },
        { name: "Michigan", abbreviation: "MI" },
        { name: "Minnesota", abbreviation: "MN" },
        { name: "Mississippi", abbreviation: "MS" },
        { name: "Missouri", abbreviation: "MO" },
        { name: "Montana", abbreviation: "MT" },
        { name: "Nebraska", abbreviation: "NE" },
        { name: "Nevada", abbreviation: "NV" },
        { name: "New Hampshire", abbreviation: "NH" },
        { name: "New Jersey", abbreviation: "NJ" },
        { name: "New Mexico", abbreviation: "NM" },
        { name: "New York", abbreviation: "NY" },
        { name: "North Carolina", abbreviation: "NC" },
        { name: "North Dakota", abbreviation: "ND" },
        { name: "Northern Mariana Islands", abbreviation: "MP" },
        { name: "Ohio", abbreviation: "OH" },
        { name: "Oklahoma", abbreviation: "OK" },
        { name: "Oregon", abbreviation: "OR" },
        { name: "Palau", abbreviation: "PW" },
        { name: "Pennsylvania", abbreviation: "PA" },
        { name: "Puerto Rico", abbreviation: "PR" },
        { name: "Rhode Island", abbreviation: "RI" },
        { name: "South Carolina", abbreviation: "SC" },
        { name: "South Dakota", abbreviation: "SD" },
        { name: "Tennessee", abbreviation: "TN" },
        { name: "Texas", abbreviation: "TX" },
        { name: "Utah", abbreviation: "UT" },
        { name: "Vermont", abbreviation: "VT" },
        { name: "Virgin Islands", abbreviation: "VI" },
        { name: "Virginia", abbreviation: "VA" },
        { name: "Washington", abbreviation: "WA" },
        { name: "West Virgina", abbreviation: "WV" },
        { name: "Wisconsin", abbreviation: "WI" },
        { name: "Wyoming", abbreviation: "WY" }
    ],
    TIMEZONES: [
        {
            name: "UTC-12:00, Y",
            abbreviation: "UTC-12:00"
        },
        {
            name: "UTC-11:00, X",
            abbreviation: "UTC-11:00"
        },
        {
            name: "UTC-10:00, W",
            abbreviation: "UTC-10:00"
        },
        {
            name: "UTC-09:00, V",
            abbreviation: "UTC-09:00"
        },
        {
            name: "UTC-08:00, U",
            abbreviation: "UTC-08:00"
        },
        {
            name: "UTC-07:00, T",
            abbreviation: "UTC-07:00"
        },
        {
            name: "UTC-06:00, S",
            abbreviation: "UTC-06:00"
        },
        {
            name: "UTC-05:00, R",
            abbreviation: "UTC-05:00"
        },
        {
            name: "UTC-04:00, Q",
            abbreviation: "UTC-04:00"
        },
        {
            name: "UTC-03:00, P",
            abbreviation: "UTC-03:00"
        },
        {
            name: "UTC-02:00, O",
            abbreviation: "UTC-02:00"
        },
        {
            name: "UTC-01:00, N",
            abbreviation: "UTC-01:00"
        },
        {
            name: "UTC+00:00, Z",
            abbreviation: "UTC+00:00"
        },
        {
            name: "UTC+01:00, A",
            abbreviation: "UTC+01:00"
        },
        {
            name: "UTC-02:00, B",
            abbreviation: "UTC+02:00"
        },
        {
            name: "UTC+03:00, C",
            abbreviation: "UTC+03:00"
        },
        {
            name: "UTC+04:00, D",
            abbreviation: "UTC+04:00"
        },
        {
            name: "UTC+05:00, E",
            abbreviation: "UTC+05:00"
        },
        {
            name: "UTC+06:00, F",
            abbreviation: "UTC+06:00"
        },
        {
            name: "UTC+07:00, G",
            abbreviation: "UTC+07:00"
        },
        {
            name: "UTC+08:00, H",
            abbreviation: "UTC+08:00"
        },
        {
            label: "UTC+09:00, I",
            abbreviation: "UTC+09:00"
        },
        {
            label: "UTC+10:00, K",
            abbreviation: "UTC+10:00"
        },
        {
            label: "UTC+11:00, L",
            abbreviation: "UTC+11:00"
        },
        {
            label: "UTC+12:00, M",
            abbreviation: "UTC+12:00"
        }

    ]
}


/** WEBPACK FOOTER **
 ** ./app/utils/constants.js
 **/